import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-form/form.min.js'
import {
  TIMING_NAME_DUPLICATE,
  TIMING_NAME_REQUIRED,
  TIMING_NAME_TOO_LONG,
  trans
} from '../../translator'

let originalMarkerName = null

$.fn.form = require('semantic-ui-form')
$.fn.transition = require('semantic-ui-transition')
$.fn.form.settings.rules.uniqueName = function (value) {
  if (value === '' || value.trim() === originalMarkerName?.trim()) {
    return true
  }

  const markerNames = []
  $('.marker-name').each(function () {
    markerNames.push($(this).text().trim())
  })

  return $.grep(markerNames, function (markerName) {
    return markerName.toLowerCase().trim() === value.toLowerCase().trim()
  }).length === 0
}

export default class extends Controller {
  static targets = [
    'createModal', 'editModal', 'editWarning',
    'deleteModal', 'deleteWarning', 'deleteConfirmButton'
  ]

  connect () {
    $('table tbody').sortable({
      handle: '.sortable-handle'
    })
    $('table tbody').on('sortupdate', (ev, ui) => {
      $.ajax({
        url: `/internal/api/markers/${ui.item[0].dataset.markerId}/reorder`,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          position: $(ui.item[0]).index()
        })
      })
    })

    this.createModal = new Modal(this.createModalTarget)
    this.editModal = new Modal(this.editModalTarget)
    this.deleteModal = new Modal(this.deleteModalTarget)

    $(document.forms.create_marker).form({
      fields: {
        create_marker_name: {
          identifier: 'create_marker_name',
          rules: [
            {
              type: 'empty',
              prompt: trans(TIMING_NAME_REQUIRED, {}, 'logs')
            },
            {
              type: 'maxLength[64]',
              prompt: trans(TIMING_NAME_TOO_LONG, {}, 'logs')
            },
            {
              type: 'uniqueName',
              prompt: trans(TIMING_NAME_DUPLICATE, {}, 'logs')
            }
          ]
        }
      },
      inline: true
    })

    $(document.forms.edit_marker).form({
      fields: {
        edit_marker_name: {
          identifier: 'edit_marker_name',
          rules: [
            {
              type: 'empty',
              prompt: trans(TIMING_NAME_REQUIRED, {}, 'logs')
            },
            {
              type: 'maxLength[64]',
              prompt: trans(TIMING_NAME_TOO_LONG, {}, 'logs')
            },
            {
              type: 'uniqueName',
              prompt: trans(TIMING_NAME_DUPLICATE, {}, 'logs')
            }
          ]
        }
      },
      inline: true
    })
  }

  create (event) {
    if (event) event.preventDefault()

    originalMarkerName = null

    const form = document.forms.create_marker
    $(form).form('set values', {
      create_marker_name: ''
    })
    this.createModal.show()
  }

  edit (event) {
    if (event) event.preventDefault()

    const row = event.currentTarget.closest('tr')
    const markerId = row.dataset.markerId
    const markerName = row.dataset.markerName
    originalMarkerName = markerName

    const isUsed = row.dataset.isMarkerUsed === '1'
    if (isUsed) {
      this.editWarningTarget.classList.remove('d-none')
    } else {
      this.editWarningTarget.classList.add('d-none')
    }

    const form = document.forms.edit_marker
    $(form).form('set values', {
      edit_marker_name: markerName,
      edit_marker_originalMarker: markerId
    })

    this.editModal.show()
  }

  submitEdit (event) {
    const form = document.forms.edit_marker
    const updatedMarkerName = form.elements['edit_marker[name]'].value

    if (updatedMarkerName.trim() === originalMarkerName.trim()) {
      this.editModal.hide()
      return
    }

    $(form).form('validate form')
    if ($(form).form('is valid')) {
      form.submit()
    }
  }

  delete (event) {
    event.preventDefault()

    const row = event.currentTarget.closest('tr')
    const isUsed = row.dataset.isMarkerUsed === '1'
    this.deleteConfirmButtonTarget.href = event.params.url

    if (isUsed) {
      this.deleteWarningTarget.classList.remove('d-none')
    } else {
      this.deleteWarningTarget.classList.add('d-none')
    }

    this.deleteModal.show()
  }
}
